import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button, IconButton, Select, Box, MenuItem, InputLabel, FormControl, useTheme
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { tokens } from "../../theme/theme";
import ClearIcon from '@mui/icons-material/Clear';

const NewDesignationDialog = ({ open, onClose, onAdd, onClear, newDesignation={}, handleInputChange }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    // const isAddDisabled =  !newDesignation.DesignationCodeDesc;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                style: {
                    position: 'absolute',
                    top: 0,
                    margin: '0px', // Adjust as needed
                },
            }}
        >
            <DialogTitle style={{ backgroundColor: theme.palette.background.default }}>
                New Designation
            </DialogTitle>
            <DialogContent style={{ backgroundColor: theme.palette.background.default }}>                
                <TextField
                    autoFocus
                    margin="dense"
                    name="DepartmentCodeDesc"
                    size='small'
                    label="Designation Description"
                    fullWidth
                    value={newDesignation.DesignationCodeDesc}
                    onChange={handleInputChange}
                    required
                    error={!newDesignation.DesignationCodeDesc}
                    helperText={!newDesignation.DesignationCodeDesc && "Designation Description is required"}
                />
                <FormControl fullWidth margin="dense" size='small'>
                    <InputLabel>Status</InputLabel>
                    <Select
                        name="DepartmentCodeStatus"
                        value={newDesignation.DesignationCodeStatus}
                        onChange={handleInputChange}
                    >
                        
                        <MenuItem value="A">Active</MenuItem>
                        <MenuItem value="IA">Inactive</MenuItem>
                    </Select>
                </FormControl>
            </DialogContent>

            <DialogActions style={{ backgroundColor: colors.primary[300]}}>
               {/* style={{ backgroundColor: theme.palette.background.default }} */}
                <Box justifyContent={'space-between'} sx={{backgroundColor:colors.primary[300]}} >

                    <Button variant='contained' style={{ fontSize: '12px', marginRight: '8px', textTransform: 'none', backgroundColor: '#1769aa' }} onClick={onAdd}>
                        Save
                    </Button>

                    <Button
                        variant='contained' onClick={onClear}
                        style={{ marginRight: '10px', fontSize: '12px', backgroundColor: '#c5c7c6', color: 'black', textTransform: 'none', }} //borderRadius:'5px 5px 0px 5px'
                    >
                        Clear
                    </Button>

                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default NewDesignationDialog;
